import React from "react";
import { ArrowRight } from "lucide-react";
import { RedWave } from "@/components/RedWave";

const PACKAGE_URL =
  "https://customer-assets.emergentagent.com/job_d2f1a296-f421-4ca2-ae61-9d54acaa8e8a/artifacts/y2e2iul5_Coffee%20Package%20Final.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden"
    >
      {/* Ambient decorative wave top-left */}
      <div className="absolute -top-10 left-0 right-0 h-24 opacity-40 pointer-events-none">
        <RedWave className="w-full h-full" strokeWidth={1} opacity={0.6} />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
        {/* Left column */}
        <div className="lg:col-span-7 relative">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-[1px] w-10 bg-[color:var(--fs-gold-muted)]" />
            <span className="text-[10px] tracking-[0.32em] uppercase text-[color:var(--fs-gold-muted)]">
              Premium Blend • Chikmagalur
            </span>
          </div>

          <h1
            className="font-display font-light text-[14vw] leading-[0.92] sm:text-7xl lg:text-[8rem] text-white"
            data-testid="hero-heading"
          >
            Enter the
            <br />
            <span className="text-gold-foil italic">Flow State</span>
          </h1>

          <div className="mt-10 max-w-md">
            <p className="font-display italic text-2xl md:text-3xl text-neutral-200 leading-snug">
              Calm Energy. Deep Focus.
            </p>
            <p className="mt-5 text-sm md:text-base text-neutral-400 leading-relaxed">
              A premium-blend coffee engineered to keep you steady, clear, and
              locked in. No spikes. No crash. Just clean, sustained focus.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#product"
              className="btn-gold"
              data-testid="hero-shop-cta"
            >
              Shop the Blend
              <ArrowRight size={14} />
            </a>
            <a
              href="#difference"
              className="text-xs tracking-[0.24em] uppercase text-neutral-400 link-wave"
              data-testid="hero-learn-link"
            >
              Why it's different
            </a>
          </div>

          {/* stats row */}
          <div className="mt-16 grid grid-cols-3 gap-6 max-w-lg">
            {[
              { k: "Medium-Dark", v: "Roast profile" },
              { k: "Low", v: "Acidity" },
              { k: "100%", v: "Premium Blend" },
            ].map((s) => (
              <div key={s.k} className="border-t border-[color:var(--fs-hairline)] pt-4">
                <div className="font-display text-2xl text-[color:var(--fs-gold-hi)]">
                  {s.k}
                </div>
                <div className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right column - package image with red aura */}
        <div className="lg:col-span-5 relative flex items-center justify-center">
          <div className="relative w-full max-w-[460px] aspect-square">
            {/* subtle red-amber aura */}
            <div className="absolute inset-0 -z-0">
              <div
                className="absolute inset-[10%] rounded-full"
                style={{
                  background:
                    "radial-gradient(closest-side, rgba(255,69,0,0.22), rgba(139,0,0,0.18) 40%, transparent 72%)",
                  filter: "blur(18px)",
                }}
              />
            </div>
            {/* wave under product */}
            <div className="absolute -bottom-4 left-[-10%] right-[-10%] h-20 pointer-events-none opacity-90">
              <RedWave className="w-full h-full" strokeWidth={2} />
            </div>

            <img
              src={PACKAGE_URL}
              alt="Flow State Coffee package"
              className="relative z-10 w-full h-full object-contain drop-shadow-[0_25px_60px_rgba(0,0,0,0.75)]"
              data-testid="hero-product-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
